import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { AppStore } from "../app-store";
import { RootStore } from "../root-store";
import { AppAction } from "./app-action";
import { BaseModel } from "./base-model";
import { Project } from "./project";
import { ProjectPermission } from "./project-permission";
import { User } from "./user";

export class ProjectMember extends BaseModel {
	@observable contactType: number;
	@observable access: number;
	@observable templateAppliedId: string;
	@observable projectId: string;
	@observable project: Project;
	@observable userId: string;
	@observable listId: string;

	constructor(data : any = {}) {
		super(data);
		this.fromJSON(data);
	}

	@action fromJSON(data : any = {}){
		super.fromJSON(data);
	}

	@action async loadPermissions(){
		await RootStore.projectPermissionStore.loadProjectPermissions(this.id);
	}

	@action async loadUser(){
		await RootStore.userStore.loadUser(this.userId);
	}

	@action async addProjectPermission(appId: string){
		try{
			this.loading = true;
			await Agent.ProjectMembers.addProjectPermission(this.id, appId);
			runInAction(() => {
				this.errorMessage = null;
			});
		}
		catch(err){
			runInAction(() => {
				this.errorMessage = err.message;
			});
		}
		finally{
			runInAction(() => {
				this.loading = false;
			});
		}
	}

	@action async removeProjectPermission(appId: string){
		try{
			this.loading = true;
			await Agent.ProjectMembers.removeProjectPermission(this.id, appId);
			runInAction(() => {
				this.errorMessage = null;
			});
		}
		catch(err){
			runInAction(() => {
				this.errorMessage = err.message;
			});
		}
		finally{
			runInAction(() => {
				this.loading = false;
			});
		}
	}

	@computed get permissions(): ProjectPermission[] {
		return RootStore.projectPermissionStore.findByMemberId(this.id);
	}

	@computed get user(): User {
		return RootStore.userStore.findById(this.userId);
	}

	@action async save(){
		await Agent.ProjectMembers.save(this.id, this);
	}

	hasAccess(access: ProjectAccess){
		return (access & this.access) == access;
	}
}

export enum ProjectAccess{
	View							= 0,
	EditMembers				= 1 << 0,
}



// WEBPACK FOOTER //
// ./src/stores/models/project-member.ts